import gql from 'graphql-tag';

export const mutationCreateRejectedSuggestions = gql`
  mutation createRejectedSuggestions (
    $suggestedDokkioTags: [SuggestedDokkioTagInput!]
    $suggestedIntegrationItemDokkioTags: [SuggestedIntegrationItemDokkioTagInput!]
    $suggestedDokkioLabelNames: [String!]
    $suggestedWebpageDokkioTags: [SuggestedWebpageDokkioTagInput!]
    $suggestedWebpageSuggestedDokkioTags: [SuggestedWebpageSuggestedDokkioTagInput!]
  ) {
    createRejectedSuggestions (
      suggestedDokkioTags: $suggestedDokkioTags
      suggestedIntegrationItemDokkioTags: $suggestedIntegrationItemDokkioTags
      suggestedDokkioLabelNames: $suggestedDokkioLabelNames
      suggestedWebpageDokkioTags: $suggestedWebpageDokkioTags
      suggestedWebpageSuggestedDokkioTags: $suggestedWebpageSuggestedDokkioTags
    )
  }
`;
export default mutationCreateRejectedSuggestions;
